import { PropsWithChildren } from 'react';

import { Container, NavBar } from '@/components';
import ROUTES from '@/router/routes';

type Props = PropsWithChildren<{
  title: string;
}>;

export const ChangeTacticLayout = ({ children, title }: Props) => {
  return (
    <>
      <NavBar
        mobile={{
          leftContent: {
            displayLogo: true,
          },
          centerContent: {
            title,
          },
          rightContent: {
            closeMenuActionUrl: ROUTES.buildTeam11,
          },
        }}
      >
        <Container className="flex relative" variant="fluid">
          {children}
        </Container>
      </NavBar>
    </>
  );
};
